import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import "./index.css";
import { connect, useSelector } from "react-redux";
import {
  UPDATE_9142A_FORM,
  UPDATE_JO_LINKING,
} from "../../../Forms/Form9142A/queries";
import {
  UPDATE_9142A_FORM_V2,
  UPDATE_JO_LINKINGV2,
} from "../../../Forms/Form9142AV2/queries";
import { withRouter } from "react-router-dom";
import renderStatusModal from "../../../../components/Forms/renderStatusModal";
import { getErrorDetails } from "../../../../components/Utils/getErrorDetails";
import "../../StatusModal/modal.css";
import FullScreenSpinner from "../../../../global/components/FullScreenSpinner";

import { store } from "../../../../global/app/store";
import LookupTableModal from "./LookupTableModal";
import { AcknowledgeModal } from "./AcknowledgeModal";
import { useMutation } from "@apollo/client";
import { cleanData } from "../../../Forms/Form9142A/helpers";
import { cleanDataV2 } from "../../../Forms/Form9142AV2/helpers";
import mappingSchema from "./mapping/mappingSchema";
import metadataMappingSchema from "./mapping/metadataMappingSchema";
import { convertMappedValue } from "./mapping/utils";

export function CaseLookup({
  input,
  schemaProps,
  formApi,
  form_ui,
  match,
  formValues,
}) {
  const user = useSelector((state) => state.appReducer.userDataReducer.data);
  const {
    subject: user_id,
    Group: { id: group_id },
  } = store.getState().appReducer.userDataReducer.data;
  const { machine_name, formVersionId } = schemaProps;
  let application_id = match.params.id;
  const is_emergency = formApi?.getState().values["a5_is_emergency"];
  const currentSelectedCase = input.value;

  const [showModal, setShowModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState(
    currentSelectedCase || undefined
  );
  const [caseOne, setCaseOne] = useState(undefined);
  const [acknowledgeModal, setAcknowledgeModal] = useState(false);

  const [isLinking, setIsLinking] = useState(false);
  const [isV2, setIsV2] = useState(formVersionId === 2);
  const [owner, setOwner] = useState();
  const [isEmergency, setIsEmergency] = useState(is_emergency);
  const [linkedFormVersionId, setLinkedFormVersionId] = useState(null);

  const [updateJOLinking, { data, loading, error }] = useMutation(
    isV2 ? UPDATE_JO_LINKINGV2 : UPDATE_JO_LINKING,
    {
      onCompleted: (data, { actionType }) => {
        if (actionType === "add") {
          renderStatusModal(true);
        }
      },
      onError: (apolloError) => {
        const { duration, message } = getErrorDetails(apolloError);
        return renderStatusModal(false, message, duration);
      }
    }
  );

  const [updateForm9142A] = useMutation(
    isV2 ? UPDATE_9142A_FORM_V2 : UPDATE_9142A_FORM,
    {
      onCompleted: () => renderStatusModal(true),
      onError: () => renderStatusModal(false),
    }
  );

  useEffect(() => {
    if (isEmergency !== is_emergency) {
      setIsEmergency(is_emergency);
      if (selectedCase) {
        handleRemove(
          undefined,
          formApi,
          updateJOLinking,
          application_id,
          selectedCase
        );
      }
    }
  }, [is_emergency]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const makeMetaDataUpdates = (formApi, values = null) => {
    const toFieldName = "linkedAgBusinessData";
    const fromFieldName = "agBusinesses";
    const formId = "9142A";

    if (!!values) {
      const valueArray =
        values?.[fromFieldName]?.map((entry) => {
          const row = {};
          metadataMappingSchema?.[formId]?.forEach(
            ({ from, to, type }) =>
              (row[to] = convertMappedValue(entry?.[from], type) || null)
          );
          return row;
        }) ?? [];
      valueArray?.push({
        fein: values?.eta_790_b15_poc_fein,
        businessName: values?.empBusinessName,
        address1: values?.emppocAddr1,
        address2: values?.emppocAddr2,
        city: values?.emppocCity,
        state: convertMappedValue(values?.emppocState, "state"),
        country: "UNITED STATES OF AMERICA",
        postalCode: values?.emppocPostcode,
        province: "N/A",
      });
      formApi.change(toFieldName, valueArray);
    } else {
      formApi.change(toFieldName, []);
    }
  };

  const handleAcknowledgeClick = (e) => {
    setAcknowledgeModal(!acknowledgeModal);
  };

  const handleRemove = async (
    e,
    formApi,
    updateJOLinking,
    application_id,
    selectedCase,
    removeOld
  ) => {
    let formId = "9142A";
    let inputObj = {
      LinkedForm9142ANumber: application_id,
      caseOwner: "deletingCase",
      islinked: false,
    };
    // To instantly lock with pageLock
    formApi.change("e3_is_job_order_complete", undefined);

    if (removeOld && currentSelectedCase) {
      inputObj.caseNumberFor790A = currentSelectedCase;
    } else {
      inputObj.caseNumberFor790A = selectedCase ? selectedCase : selectedCase;
    }

    delete form_ui.__typename;
    let newVals = {
      ...formValues,
      formVersionId: linkedFormVersionId,
      e3_is_job_order_complete: null,
    };

    let updatedJO = await updateJOLinking({
      variables: {
        [isV2 ? "Form9142AFormDataV2" : "Form9142AFormData"]: isV2
          ? cleanDataV2(newVals)
          : cleanData(newVals),
        id: application_id,
        formUI9142A: form_ui,
        Form790LookupUpdateInput: inputObj,
      },
      actionType: "remove",
    });

    if (updatedJO?.data && !updatedJO.errors) {
      setCaseOne(undefined);
      setSelectedCase(undefined);
      mappingSchema?.[formId]?.forEach(({ to }) =>
        formApi.change(to, undefined)
      );

      !isV2 && makeMetaDataUpdates(formApi);
      /*
       * Remove a1a employer response in case they linked a formVersionId 2 case
       * and then went back to link a formVersionId 1 case
       */
      formApi.change("a1_employer_type_a", undefined);
    } else {
      formApi.change("e3_is_job_order_complete", selectedCase);
    }
  };

  const sendToAcknowledge = (e) => {
    setShowModal(!showModal);
    setAcknowledgeModal(true);
  };

  const acknowledgeCancel = (e) => {
    setShowModal(false);
    setAcknowledgeModal(false);
    setSelectedCase(undefined);
  };

  return (
    <div>
      {isLinking && <FullScreenSpinner />}
      <button
        className={"usa-button usa-button usa-button-primary"}
        type="button"
        onClick={() => setShowModal(true)}
      >
        Job Order Lookup
      </button>
      <LookupTableModal
        showModal={showModal}
        sendToAcknowledge={sendToAcknowledge}
        setOwner={setOwner}
        isV2={isV2}
        isLinking={isLinking}
        caseOne={caseOne}
        selectedCase={selectedCase}
        setSelectedCase={setSelectedCase}
        toggleModal={toggleModal}
        user_id={user_id}
        group_id={group_id}
        schemaProps={schemaProps}
        formApi={formApi}
        isEmergency={isEmergency}
      />
      <AcknowledgeModal
        updateJOLinking={updateJOLinking}
        updateForm9142A={updateForm9142A}
        acknowledgeCancel={acknowledgeCancel}
        acknowledgeModal={acknowledgeModal}
        handleAcknowledgeClick={handleAcknowledgeClick}
        setAcknowledgeModal={setAcknowledgeModal}
        owner={owner}
        isV2={isV2}
        setIsLinking={setIsLinking}
        setCaseOne={setCaseOne}
        currentSelectedCase={currentSelectedCase}
        selectedCase={selectedCase}
        setSelectedCase={setSelectedCase}
        handleRemove={handleRemove}
        makeMetaDataUpdates={makeMetaDataUpdates}
        linkedFormVersionId={linkedFormVersionId}
        setLinkedFormVersionId={setLinkedFormVersionId}
        input={input}
        application_id={application_id}
        formApi={formApi}
        formValues={formValues}
        form_ui={form_ui}
      />
      <input
        {...input}
        type={"hidden"}
        name={machine_name}
        id={machine_name}
        value={input.value}
      />
      {caseOne || input.value ? (
        <div className={"selection-area"}>
          <FaTimes
            onClick={(e) => {
              handleRemove(
                e,
                formApi,
                updateJOLinking,
                application_id,
                input.value
              );
            }}
            size={15}
            color={"#981b1e"}
            className={"remove-icon"}
          />
          <span className={"selected-case"}>{caseOne || input.value}</span>
        </div>
      ) : null}
    </div>
  );
}

export default withRouter(CaseLookup);
